import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Reveal, Eyebrow } from "./Reveal";
import { PrimaryButton } from "./Buttons";
import { useAuth } from "./AuthContext";

const API = process.env.REACT_APP_BACKEND_URL;

export const PricingPanel = ({ eyebrow, title, price, regular, note, bullets = [], onBuild, testId, packageKey }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const startPackage = async () => {
    if (!user || !packageKey) {
      onBuild();
      return;
    }
    try {
      const res = await fetch(`${API}/api/packages/start`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ package: packageKey }),
      });
      if (res.ok) {
        navigate("/account");
        return;
      }
    } catch {
      /* fall through to inquiry */
    }
    onBuild();
  };

  return (
    <Reveal>
    <div
      data-testid={testId}
      className="grid gap-10 rounded-[2rem] bg-gradient-to-br from-[#c8b8f0] via-lilac to-[#a78fe0] p-8 text-ink sm:p-12 lg:grid-cols-[1.15fr_1fr] lg:items-center lg:gap-14"
    >
      <div>
        <Eyebrow tone="dark" testId={`${testId}-eyebrow`}>
          {eyebrow}
        </Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight sm:text-4xl">{title}</h2>
        <ul className="mt-7 space-y-3.5">
          {bullets.map((item) => (
            <li key={item} className="flex items-center gap-3 text-sm font-bold text-ink/85">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ink/90 text-lilac">
                <Check className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" />
              </span>
              {item}
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-3xl bg-ink p-8 text-paper shadow-[0_30px_60px_-24px_rgba(0,0,0,0.55)] sm:p-10">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-paper/45">One-time investment</p>
        <p className="mt-4 flex flex-wrap items-end gap-x-4 gap-y-1">
          <span data-testid={`${testId}-price`} className="font-display text-5xl font-extrabold tracking-tight text-lilac">
            {price}
          </span>
          <span className="pb-2 text-sm text-paper/40 line-through">{regular}</span>
        </p>
        <p className="mt-3 text-sm text-paper/60">{note}</p>
        <PrimaryButton testId={`${testId}-cta`} onClick={startPackage} className="mt-7 w-full">
          {user && packageKey ? "Start this package" : "Request a launch proposal"}
        </PrimaryButton>
        <p className="mt-4 text-center text-xs text-paper/40">
          {user && packageKey
            ? "Reserve it now — scope, timeline, and payment are confirmed together after. Track every step from your account."
            : "Scope, timeline, and payment are confirmed together after your inquiry."}
        </p>
      </div>
    </div>
    </Reveal>
  );
};
